import React from "react";
export function Guarantee() {
  return <section id="garantia" className="bg-paper" data-id="element-129" data-mp="1qac7xuu2siv8">
      <div className="mx-auto flex max-w-4xl items-center gap-5 px-5 py-10 md:gap-10 md:px-8 md:py-20" data-id="element-130" data-mp="1o46jwlmjxow3">
        <div className="flex h-20 w-20 shrink-0 flex-col items-center justify-center rounded-full bg-cream ring-2 ring-gold ring-offset-2 ring-offset-paper md:h-40 md:w-40 md:ring-4 md:ring-offset-4" data-id="element-131" data-mp="223y26yk3prfw">
          <span className="font-display text-3xl leading-none text-wine md:text-6xl" data-id="element-132" data-mp="19dzcd0y31qa6">7</span>
          <span className="mt-0.5 text-[9px] font-bold tracking-[0.2em] text-forest md:mt-1 md:text-xs" data-id="element-133" data-mp="14g64m3h4so7s">DÍAS</span>
          <span className="hidden text-[10px] font-semibold tracking-[0.15em] text-muted md:block" data-id="element-134" data-mp="1j5lulh8u8pmf">GARANTÍA TOTAL</span>
        </div>
        <div data-id="element-135" data-mp="1ecizv5sbra4n">
          <h2 className="font-display text-xl leading-tight text-forest md:text-4xl" data-id="element-136" data-mp="1ec0unjnoplkl">
            7 días para probarlo o te devolvemos el 100%
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-muted md:mt-4 md:text-lg" data-id="element-137" data-mp="lodd6dhpnb26">
            Abrís los tomos, probás las recetas en tu cocina. Si no es lo que esperabas: sin preguntas, sin formularios,
            sin drama. <span className="text-ink" data-id="element-138" data-mp="twrw0r8j5qtk">(Tasa de devoluciones menor al 1%)</span>
          </p>
        </div>
      </div>
    </section>;
}